

function Rules02() {
    return (
        <div className="w-7/12 text-right drtl leading-8 border-b border-slate-200 py-10">
            <h2 className="font-bold text-xl text-slate-700">۲. تعاریف</h2>
            <p className="mr-10 text-sm leading-8">
                <span className="font-bold">بوستان : </span>
                یک شبکه اجتماعی پیام‌رسان است که با توجه به امکاناتی که برای اشخاص و کسب و کارها فراهم کرده است.
            </p>
            <p className="mr-10 text-sm leading-8">
                <span className="font-bold">حساب کاربری : </span>
                پس از ثبت نام و عضویت هر کاربر، برای ایشان یک حساب کاربری ایجاد می‌شود و هر کاربر می‌تواند از کلیه خدمات بوستان در حساب ایجاد شده، استفاده نماید.
            </p>
            <p className="mr-10 text-sm leading-8">
                <span className="font-bold">کد دعوت : </span>
                کدی متشکل از چند رقم یا حروف یا ترکیبی از آن دو است و منحصر به فرد که به همراه سه حرف BLE به کاربر اختصاص داده می‌شود. با ثبت‌نام هر کاربر این کد ایجاد شده و کاربر می‌تواند از آن برای دعوت دوستان خود به بوستان استفاده نماید. در صورتی که شخصی کد دعوت شما را در حساب خود وارد نماید هر دو مطابق با مقررات و شرایط سایت امتیاز دریافت خواهید کرد و می‌توانید در جشنواره‌های بوستان و قرعه کشی جوایز آن، شانس خود را امتحان نمایید.
            </p>
            <p className="mr-10 text-sm leading-8">
                <span className="font-bold">گروه : </span>
                گروه برای به‌اشتراک‌گذاری مطالب بین تعدادی از افراد با حداکثر تعداد 50 هزار نفر می‌باشد. گروه‌ها به دو دسته عمومی و خصوصی تقسیم می‌شوند. کاربران می‌توانند گروه‌های عمومی دارای شناسه کاربری را از طریق جستجو پیدا کنند و عضو شوند. همچنین ممکن است بوستان گروه‌های عمومی دارای شناسه کاربری که دارای محتوای کاربردی و مفید هستند را به کاربران خود پیشنهاد دهد.

                در گروه‌های خصوصی تنها راه افزوده‌شدن از طریق دعوت مالک و مدیر است.
            </p>
            <p className="mr-10 text-sm leading-8">
                <span className="font-bold">کانال : </span>
                کانال‌ها ابزاری برای پخش پیام به مخاطبان هستند که می‌توانند تعداد نامحدودی مشترک داشته باشند. کانال‌ها به دو دسته عمومی و خصوصی تقسیم می‌شوند: کانال‌های عمومی دارای نام کاربری هستند. هرکس می‌تواند با سرچ در بوستان آن‌ها را پیدا کند و عضو شود. کانا‌ل‌های خصوصی قابل جست‌وجو نیستند و فقط با لینک دعوت یا اضافه‌شدن توسط مالک یا مدیر می‌توان در آن‌ها عضو شد.
            </p>

        </div>
    );
}

export default Rules02;